module.exports = __webpack_public_path__ + "static/media/img2.b34b60e9.jpg";